// extracted by mini-css-extract-plugin
export default {"treeView":"tree_view_treeView__THqyy typography_text--sm__BgKHZ"};